import gql from 'graphql-tag'
import { openingHours } from './fragments'

const mutation = gql`
mutation updateShop($id: ID!, $fields: ShopInput!) {
	cashAssist {
		updateShop(id: $id, fields: $fields) {
			id
			mod_ver
			name
			regionId
			timeTrackingToken
			qrMenuCashRegisterId
			clickCollectCashRegisterId
			...openingHours
		}
	}
}
${openingHours}
`
export default mutation
